import { tns } from '../../../../node_modules/tiny-slider/src/tiny-slider.js';

function compareCardsInit() {
  const cardsSlider = document.querySelectorAll('[data-compare-cards]');

  if (!cardsSlider.length) return;

  cardsSlider.forEach((slider) => {
    // tns-items are inline-block — h-100 alone cannot equalize row height
    const equalizeCardHeights = () => {
      const cards = slider.querySelectorAll('.c-compare_card');

      cards.forEach((card) => {
        card.style.minHeight = '';
      });

      let maxHeight = 0;

      cards.forEach((card) => {
        maxHeight = Math.max(maxHeight, card.offsetHeight);
      });

      if (maxHeight > 0) {
        cards.forEach((card) => {
          card.style.minHeight = `${maxHeight}px`;
        });
      }
    };

    // Wait for layout paint — sync call right after tns() is too early on first load
    const scheduleEqualize = () => {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(equalizeCardHeights);
      });
    };

    const sliderInstance = tns({
      container: slider,
      items: 1,
      // Shadow room is CSS padding on .tns-ovh — edgePadding would double the inset
      edgePadding: 0,
      gutter: 40,
      slideBy: 1,
      autoplay: false,
      controlsPosition: 'bottom',
      controlsText: ['Vorige', 'Volgende'],
      nav: true,
      navPosition: 'bottom',
      arrowKeys: true,
      speed: 400,
      loop: false,
      rewind: false,
      touch: true,
      mouseDrag: true,
      preventScrollOnTouch: 'auto',
      responsive: {
        667: {
          items: 2
        },
        992: {
          items: 3
        }
      },
      onInit: scheduleEqualize
    });

    const setControlsActive = () => {
      const info = sliderInstance.getInfo();
      const frame = slider.closest('.c-compare_frame');

      if (frame) {
        frame.classList.toggle('-controls-active', info.slideCount > info.items);
      }
    };

    const refresh = () => {
      setControlsActive();
      scheduleEqualize();
    };

    setControlsActive();
    scheduleEqualize();

    sliderInstance.events.on('indexChanged', scheduleEqualize);
    sliderInstance.events.on('newBreakpointEnd', refresh);

    slider.querySelectorAll('img').forEach((img) => {
      if (!img.complete) {
        img.addEventListener('load', scheduleEqualize, { once: true });
      }
    });

    window.addEventListener('load', scheduleEqualize);
    window.addEventListener('resize', () => {
      window.requestAnimationFrame(refresh);
    });
  });
}
compareCardsInit();
